import React, { Component } from 'react';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { FieldGroup } from '../../helpers/BootstrapHelpers';

import tourDef from '../../productTour/TourDef';

import './Profile.css';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';

class GeneralProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: props.userId,
            accessToken: authService.authenticatedUserAccessToken,
            firstName: null,
            lastName: null,
            displayName: null,
            degrees: null,
            address1: null,
            address2: null,
            city: null,
            state: null,
            postalCode: null,
            country: null,
            phone: null,
            email: null,
            cellPhone: null,
            signature: null,
            cadeFirstPage: null,
            runTours: true,
            organizationId: 0,
            organizationName: null,
            organizationDescription: null,
            organizationAddress1: null,
            organizationAddress2: null,
            organizationCity: null,
            organizationState: null,
            organizationPostalCode: null,
            organizationCountry: null,
            organizationPhone: null,
            organizationWebsite: null,
            organicationLogo: null
        }
        this.hasChanged = false;
    }

    infoChangeHandler = (e) => {
        this.state[e.target.id] = e.target.value;
        this.hasChanged = true;
    }

    firstPageHandler = (e) => {
        this.setState({ cadeFirstPage: e.target.value });
        this.hasChanged = true;
    }

    tourHandler = (e) => {
        this.setState({ runTours: e.target.checked });
        this.hasChanged = true;
        tourDef.setRunTours(e.target.checked);
    }


    infoSaveHandler = () => {
        if (this.hasChanged) {
            // Validate user info
            let errorMessage = this.validateUserInfo();
            if (errorMessage != null) {
                alertPopup('warning', errorMessage);
                return;
            }

            errorMessage = this.validateOrgInfo();
            if (errorMessage != null) {
                alertPopup('warning', errorMessage);
                return;
            }

            let url = "/account/" + this.state.id;
            api.post(url, this.state,
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                if (response.status != 200) {
                    apiErrorPopup(apiResponseHandler(response));
                };
                this.hasChanged = false;
            })
            .catch((error) => {
                // Major problem!
                apiErrorPopup(apiErrorHandler(error));
                return;
            });
        }
    }

    validateUserInfo() {
        let errorMessage = null;

        // Must have non-null first and last name.
        if (isNullOrEmpty(this.state.firstName)) {
            errorMessage = "Please correct the following errors:  1. First name must be provided. ";
        }
        if (isNullOrEmpty(this.state.lastName)) {
            errorMessage += "2. Last name must be provided. ";
        }
        return errorMessage;
    }

    validateOrgInfo() {
        // Nothing is required.
        return null;
    }

    componentDidMount() {

        // Run a query and get the current user info.
        let url = "account/" + this.state.id;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then(response => {
                if (response.status == 200) {

                    // Retain authenticated user information in state.
                    this.setState({
                            id: response.data.id,
                            accessToken: authService.authenticatedUserAccessToken,
                            firstName: response.data.firstName,
                            lastName: response.data.lastName,
                            displayName: response.data.displayName,
                            degrees: response.data.degrees,
                            address1: response.data.address1,
                            address2: response.data.address2,
                            city: response.data.city,
                            state: response.data.state,
                            postalCode: response.data.postalCode,
                            //country: response.data.country,
                            phone: response.data.phone,
                            email: response.data.email,
                            //signature: response.data.signature,
                            cellPhone: response.data.cellPhone,
                            cadeFirstPage: response.data.cadeFirstPage,
                            runTours: response.data.runTours,
                            organizationId: response.data.organizationId,
                            organizationName: response.data.organizationName,
                            organizationDescription: response.data.organizationDescription,
                            organizationAddress1: response.data.organizationAddress1,
                            organizationAddress2: response.data.organizationAddress2,
                            organizationCity: response.data.organizationCity,
                            //state: response.data.organizationState,
                            organizationPostalCode: response.data.organizationPostalCode,
                            //country: response.data.organizationCountry,
                            organizationPhone: response.data.organizationPhone,
                            organizationWebsite: response.data.organizationWebsite,
                            //logo: response.data.organizationLogo
                    })
                }
                else {
                    // Major problem - should not happen.  Back to login
                    apiErrorPopup("Sorry...Something has gone wrong. Please login again.");
                    authService.setAuthenticated(null, null, 0, null, null, null, null, false, false, false, false, false, -1, null);
                    this.setState({
                        id: 0

                    })
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login
                authService.setAuthenticated(null, null, 0, null, null, null, null, false, false, false, false, false, -1, null);
                this.setState({
                    id: 0

                })
            });
    }

    render() {
        let orgLabel = null;
        if (authService.isClearClinician) {
            orgLabel = "Organization";
        }
        else {
            orgLabel = "Work";
        }
        
        return (
            <Card onMouseLeave={this.infoSaveHandler} >
            <Container>
                <Form>
                <Row>
                    <Col sm={6}>
                        <h4 className="profile_GenInfoHdr">Personal Information</h4>
                    </Col>
                    <Col sm={6}>
                        <h4 className="profile_GenInfoHdr">{orgLabel} Information</h4>
                    </Col>
                </Row>
                <Row>

                    <Col sm={6}>
                        <FieldGroup
                            id="firstName"
                            type="text"
                            label="First Name"
                            placeholder="First name (required)"
                            defaultValue={this.state.firstName}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="lastName"
                            type="text"
                            label="Last Name"
                            placeholder="Last name (required)"
                            defaultValue={this.state.lastName}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="displayName"
                            type="text"
                            label="Display Name"
                            placeholder="Optional nickname to use in CADE"
                            defaultValue={this.state.displayName}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="degrees"
                            type="text"
                            label="List of Degrees"
                            placeholder="E.g.: Ph.D, M.D."
                            defaultValue={this.state.degrees}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="phone"
                            type="text"
                            label="Business Phone"
                            placeholder="(888)888-8888"
                            defaultValue={this.state.phone}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="cellPhone"
                            type="text"
                            label="Cell Phone"
                            placeholder="(888)888-8888"
                            defaultValue={this.state.cellPhone}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="email"
                            type="text"
                            label="Email"
                            placeholder="youremail@somewhere.com"
                            defaultValue={this.state.email}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="address1"
                            type="text"
                            label="Address 1"
                            placeholder="1555 Sample Lane"
                            defaultValue={this.state.address1}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="address2"
                            type="text"
                            label="Address 2"
                            placeholder="P.O Box 222"
                            defaultValue={this.state.address2}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="city"
                            type="text"
                            label="City"
                            placeholder="Boulder"
                            defaultValue={this.state.city}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="state"
                            type="text"
                            label="State"
                            placeholder="CO"
                            defaultValue={this.state.state}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="postalCode"
                            type="text"
                            label="Postal Code"
                            placeholder="80304"
                            defaultValue={this.state.postalCode}
                            onKeyUp={this.infoChangeHandler}
                        />
                    </Col>

                    <Col sm={6}>
                        <FieldGroup
                            id="organizationName"
                            type="text"
                            label="Organization Name"
                            placeholder="Organization name (optional)"
                            defaultValue={this.state.organizationName}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="organizationWebsite"
                            type="text"
                            label="Website"
                            placeholder="www/exampleorg.com"
                            defaultValue={this.state.organizationWebsite}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="organizationPhone"
                            type="text"
                            label="Organization Phone"
                            placeholder="(888)888-8888"
                            defaultValue={this.state.organizationPhone}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="organizationAddress1"
                            type="text"
                            label="Address 1"
                            placeholder="1555 Sample Lane"
                            defaultValue={this.state.organizationAddress1}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="organizationAddress2"
                            type="text"
                            label="Address 2"
                            placeholder="Suite 555"
                            defaultValue={this.state.organizationAddress2}
                            onKeyUp={this.infoChangeHandler}
                        />
                        <FieldGroup
                            id="organizationCity"
                            type="text"
                            label="City"
                            placeholder="Denver"
                            defaultValue={this.state.organizationCity}
                            onKeyUp={this.infoChangeHandler}
                                />
                            {false &&
                                <FieldGroup
                                    id="organizationState"
                                    type="text"
                                    label="State"
                                    placeholder="CO"
                                    defaultValue={this.state.organizationState}
                                    onChange={this.infoChangeHandler}
                                />
                            }
                        <FieldGroup
                            id="organizationPostalCode"
                            type="text"
                            label="Postal Code"
                            placeholder="80221"
                            defaultValue={this.state.organizationPostalCode}
                            onKeyUp={this.infoChangeHandler}
                            />
                        <h4 className="profile_GenInfoHdr">First Page After Login</h4>
                        <Form.Check checked={this.state.cadeFirstPage == "/gettingstarted"} onChange={this.firstPageHandler} inline label="Getting Started" type="radio" value="/gettingstarted" id="gettingstarted" />
                        <Form.Check checked={this.state.cadeFirstPage == "/home"} onChange={this.firstPageHandler} inline label="Assessment Selection" type="radio" value="/home" id="home" />
                        <h4 className="profile_GenInfoHdr">Product Tours</h4>
                                <Form.Check checked={this.state.runTours} onChange={this.tourHandler} inline label="Play product tours" type="switch" id="runTours" />
                    </Col>
                    </Row>
                </Form>
                </Container>
            </Card>
        )
    }
}

export default GeneralProfile;


// WEBPACK FOOTER //
// ./src/components/Profile/GeneralProfile.js